import { LogIn, LogOut, User } from "lucide-react";
import { useCfxAuth } from "@/context/CfxAuthContext";

export default function CfxLoginButton({ compact = false }) {
  const { user, login, logout, loading } = useCfxAuth();

  if (loading) {
    return (
      <div
        className={`flex items-center justify-center rounded-full border border-[var(--theme-border)] text-[var(--muted)] font-mono text-[10px] tracking-widest ${
          compact ? "w-9 h-9" : "px-3 h-10"
        }`}
      >
        ...
      </div>
    );
  }

  if (user) {
    return (
      <div className="flex items-center gap-2">
        <div
          data-testid="cfx-user-chip"
          className="hidden sm:flex items-center gap-2 rounded-full border border-[var(--theme-accent-primary)]/30 bg-[var(--theme-accent-primary)]/5 pl-1.5 pr-3 h-10"
        >
          {user.cfx_avatar_url ? (
            <img
              src={user.cfx_avatar_url}
              alt=""
              className="w-7 h-7 object-cover rounded-full border border-[var(--theme-accent-primary)]/30"
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
          ) : (
            <User size={14} className="text-[var(--accent)] shrink-0 ml-1.5" />
          )}
          <span className="text-xs font-semibold text-white tracking-wide whitespace-nowrap">
            {user.cfx_username}
          </span>
        </div>
        <button
          data-testid="cfx-logout"
          onClick={logout}
          aria-label="Log out of CFX"
          title="Log out of CFX"
          className="w-10 h-10 flex items-center justify-center rounded-full border border-[var(--theme-border)] hover:border-red-500/70 hover:text-red-400 hover:bg-red-500/10 text-[var(--muted)] transition-colors"
        >
          <LogOut size={15} />
        </button>
      </div>
    );
  }

  return (
    <button
      data-testid="cfx-login-btn"
      onClick={login}
      className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] rounded-full border border-[var(--theme-accent-primary)]/40 text-[var(--accent)] hover:bg-[var(--accent)] hover:text-black hover:shadow-[0_0_20px_-4px_rgba(var(--theme-accent-primary-rgb),0.6)] px-4 h-10 transition-colors"
    >
      <LogIn size={13} />
      <span className="hidden sm:inline">CFX Login</span>
    </button>
  );
}
